$(document).ready(function () {
  $(".product-selector_block").click(function () {
    $(this)
      .closest(".product-selector_outer")
      .find(".product-selector_block")
      .removeClass("active");
    $(this).addClass("active");
      var option_name =  $(this).attr('data-bottles');
   if(option_name != '1'){
    $('.custom-b.custom-icon-box-sec .icon-img,.custom-b.custom-icon-box-sec h3.title').show();
  $('.custom-b.custom-icon-box-sec .locked_icon,.custom-b.custom-icon-box-sec .locked').hide();
  $('.custom-b.custom-icon-box-sec .custom-row').removeClass('locked-container');
   }else{
    $('.custom-b.custom-icon-box-sec .icon-img,.custom-b.custom-icon-box-sec h3.title').hide();
    $('.custom-b.custom-icon-box-sec .locked_icon,.custom-b.custom-icon-box-sec .locked').show();
    $('.custom-b.custom-icon-box-sec .custom-row').addClass('locked-container');
   }
  });

  $(".pp_var_autoship").click(function () {
    $(this).toggleClass("disabled");
    if ($(".pp_var_autoship").hasClass("disabled")) {
      $('.product-selector_outer[data="sub"]').removeClass("active_block");
      $('.product-selector_outer[data="otp"]').addClass("active_block");
    } else {
      $('.product-selector_outer[data="sub"]').addClass("active_block");
      $('.product-selector_outer[data="otp"]').removeClass("active_block");
    }
  });

  $(".product-selector_atc").click(function () {
    const $btn = $(this);

    // Redirect logic for Champs
    if ($btn.attr("data-mode-champs") == "true") {
        const newUrl = $(".product-selector_outer.active_block")
            .find(".product-selector_block.active")
            .attr("data-champs-url");

        window.location.href = newUrl;
        return;
    }

    // Collect variant
    const $activeBlock = $(".product-selector_outer.active_block");
    const currentId = $activeBlock.find(".product-selector_block.active").attr("data-id");
    const mode = $activeBlock.attr("data");
    const currentSellingPlan = $activeBlock.find(".product-selector_block.active").attr("data-selling-plan");

    const data = mode === "sub"
        ? { id: currentId, quantity: 1, selling_plan: currentSellingPlan }
        : { id: currentId, quantity: 1 };

    const cartDrawer = document.getElementById("cart-drawer");

    // Add to cart
    $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        dataType: "json",

        success: async function () {
            console.log("✅ Added to cart:", currentId);

            // ✅ Refresh drawer contents
            await refreshCartDrawerInner();

            // ✅ Dispatch Shopify event (your cart listens to this!)
            document.dispatchEvent(
                new CustomEvent("cart:change", {
                    bubbles: true,
                    detail: { baseEvent: "cart:add" }
                })
            );

            // ✅ Open the drawer
            cartDrawer?.show?.();
        },

        error: function () {
            alert("Error adding item to the cart.");
        },
    });
});



});
